import { produce } from 'immer';

import JobsApis from '../../apis/aeJobs';
import { GET_ALL_JOBS, HIDE_TOAST, JOB_DETAIL, SEARCH_JOBS, SHOW_TOAST, SAVE_JOB, SAVED_JOBS_LIST, APPLY_JOB, APPLIED_JOBS_LIST } from '../../types';
import { showToast } from '../aeToast';
import { signOut } from '../auth';

import { ERROR_MSG, ERROR_MSG_401 } from '../../../constants';

export const getAllJobs = () => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await JobsApis.searchJobs({ conditions: {} });

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          resolve(res_data);
          dispatch({ type: `${GET_ALL_JOBS}_success`, payload: res_data });
        }
      } catch (err) {
        reject(err);
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${GET_ALL_JOBS}_failed`, payload });
      }
    };

    dispatch({ type: `${GET_ALL_JOBS}_started` });

    return Promise.resolve(callApi());
  });

export const searchJobs = (payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await JobsApis.searchJobs(payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          resolve(res_data);
          dispatch({ type: `${SEARCH_JOBS}_success`, payload: res_data });
        }
      } catch (err) {
        reject(err);
      }
    };

    dispatch({ type: `${SEARCH_JOBS}_started` });

    return Promise.resolve(callApi());
  });

export const getJobDetails =
  (id, ctx = {}) =>
  (dispatch) =>
    new Promise((resolve, reject) => {
      const callApi = async () => {
        try {
          const res = await JobsApis.getJobDetails(id, ctx.req);

          if (res.status === 500) {
            throw res;
          }

          if (res.status === 401) {
            dispatch(showToast('error', ERROR_MSG_401));
            dispatch(signOut());
          }

          const res_data = await res.json();

          if (!res.ok) {
            throw res_data;
          } else {
            dispatch({ type: `${JOB_DETAIL}_success`, payload: res_data });
            resolve(res_data);
          }
        } catch (err) {
          const payload = err && err.message ? err : { message: ERROR_MSG };

          dispatch({ type: `${JOB_DETAIL}_failed`, payload });
          reject(err);
        }
      };

      dispatch({ type: `${JOB_DETAIL}_started` });

      return Promise.resolve(callApi());
    });

export const saveJob = (id) => (dispatch, getstate) =>
  new Promise((resolve, reject) => {
    const state = getstate();
    const jobs = state.search_jobs?.data?.data?.jobs || [];
    const callApi = async () => {
      try {
        const res = await JobsApis.saveJob(id);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          const updated_jobs = jobs.map((job) => (job.id === id ? { ...job, saved_job: res_data.data } : job));
          const updated_data = produce(state.search_jobs?.data, (draft) => {
            draft.data.jobs = updated_jobs;
          });

          dispatch({ type: `${SEARCH_JOBS}_success`, payload: updated_data });
          dispatch({
            type: `${SHOW_TOAST}`,
            payload: { type: 'success', message: 'Job saved successfully.' }
          });
          dispatch({ type: `${SAVE_JOB}_success`, payload: res_data });
          resolve('success');
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${SAVE_JOB}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });

export const deleteJob = (id, pathname) => (dispatch, getstate) =>
  new Promise((resolve, reject) => {
    const state = getstate();
    const jobs = state.search_jobs?.data?.data?.jobs || [];
    const callApi = async () => {
      try {
        const res = await JobsApis.deleteSavedJob(id);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          if (pathname === '/jobs/explore') {
            const updated_jobs = jobs.map((job) => (job.saved_job?.id === id ? { ...job, saved_job: null } : job));

            const updated_data = produce(state.search_jobs?.data, (draft) => {
              draft.data.jobs = updated_jobs;
            });

            dispatch({ type: `${SEARCH_JOBS}_success`, payload: updated_data });
          }

          dispatch({
            type: `${SHOW_TOAST}`,
            payload: { type: 'success', message: 'Job was unsaved successfully.' }
          });
          dispatch({ type: `${SAVE_JOB}_success`, payload: res_data });
          resolve('success');
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${SAVE_JOB}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });

export const getSavedJobs = (req_body) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await JobsApis.getSavedJobs(req_body);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({ type: `${SAVED_JOBS_LIST}_success`, payload: res_data });
          resolve(res_data);
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${SAVED_JOBS_LIST}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${SAVED_JOBS_LIST}_started` });

    return Promise.resolve(callApi());
  });

export const applyJob = (id, payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await JobsApis.applyJob(id, payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({
            type: `${SHOW_TOAST}`,
            payload: { type: 'success', message: 'Application was submitted successfully.' }
          });
          dispatch({ type: `${APPLY_JOB}_success`, payload: res_data });
          resolve(res_data);
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${APPLY_JOB}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });

export const myApplications = (payload) => (dispatch, getstate) =>
  new Promise((resolve, reject) => {
    const state = getstate();
    const user = state.currentUser.data;

    if (!user) {
      return;
    }

    const callApi = async () => {
      try {
        const res = await JobsApis.myApplications(payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({ type: `${APPLIED_JOBS_LIST}_success`, payload: res_data });
          resolve(res_data);
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${APPLIED_JOBS_LIST}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${APPLIED_JOBS_LIST}_started` });

    return Promise.resolve(callApi());
  });
